module.exports = __webpack_public_path__ + "media/feature/event6-8eaea53c.jpg";